var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5798 6.66634C11.5798 10.6663 6.24648 14.6663 6.24648 14.6663C6.24648 14.6663 0.913147 10.6663 0.913147 6.66634C0.913147 5.25185 1.47505 3.8953 2.47524 2.8951C3.47544 1.89491 4.83199 1.33301 6.24648 1.33301C7.66097 1.33301 9.01752 1.89491 10.0177 2.8951C11.0179 3.8953 11.5798 5.25185 11.5798 6.66634Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24648 8.66634C7.35105 8.66634 8.24648 7.77091 8.24648 6.66634C8.24648 5.56177 7.35105 4.66634 6.24648 4.66634C5.14191 4.66634 4.24648 5.56177 4.24648 6.66634C4.24648 7.77091 5.14191 8.66634 6.24648 8.66634Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.a66df7dc4a093d6b9e0478b46dd47e0c.svg";
export { ForwardRef as ReactComponent };